import initPanel from "src/modules/pe-landing-module/data/initPanels"
import { getLandingContainer } from "../../utils/getLandingContainer"
import PanelLayout from "../../UIX/PanelLayout"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILandingEditPanelProps {
   
}
const LandingEditPanel = (props: ILandingEditPanelProps): JSX.Element => {
    const settings  				= useLandingConsoleStore((state:ILandingConsoleStore) => state.settings) 
    return !!settings.panels 
        ?
        <PanelLayout
            layoutId="landing"
            layoutElement={ getLandingContainer() }
            initData={ initPanel() }
        />
        :
        <></>
}
export default LandingEditPanel